import { CircleHelp } from 'lucide-react'

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

// 列名だけでは意味が伝わらない項目に付けるヘルプアイコン（v1 ColumnTitleWithHelp と同じ）。
// 発注照合テーブル（orders-table-columns.tsx）から切り出した共通部品。他の一覧テーブルも同じ見た目・挙動に揃える
export function ColumnHelp({ title, help }: { title: string; help: string }) {
  return (
    <Tooltip>
      <TooltipTrigger
        // ソート可能な列は見出し全体を <button> で包んでいるため、既定の <button> レンダリングのままだと
        // ボタンの入れ子（invalid HTML）になる。span でレンダリングし、v1（アイコンのみ・非ボタン）と揃える。
        // role="button" は付けない。クリックしても何も実行せず（ツールチップはホバー/フォーカスで開く）、
        // 押せない要素をボタンとして支援技術に公開しないため（CodeRabbit 指摘）。tabIndex はフォーカスで
        // ツールチップを開くために残す
        render={<span tabIndex={0} />}
        // ソート可能な列ではヘッダー全体がソートのクリック領域になっているため、
        // 説明を読もうとしてアイコンを押しただけで並び順が変わらないようにする（v1 と同じ理由）
        onClick={(event) => {
          event.stopPropagation()
        }}
        aria-label={`${title}とは`}
        data-testid={`column-help-${title}`}
        className="inline-flex text-muted-foreground/60 hover:text-muted-foreground"
      >
        <CircleHelp className="size-3.5" aria-hidden="true" />
      </TooltipTrigger>
      <TooltipContent>{help}</TooltipContent>
    </Tooltip>
  )
}
